import { css } from "@emotion/react";

import { animations, colors, timing } from "@styles";

export const noStyleButton = css`
  display: flex;
  padding: 1rem;
  justify-content: space-between;
  align-items: center;
  color: ${colors.grey.base};
  margin: 0 auto;
  @supports (width: fit-content) {
    width: fit-content;
  }

  &:active {
    .icon-chevron {
      margin-right: 2rem;
    }
  }
`;

export const chevron = css`
  margin-right: 1rem;
  transition: margin ${timing.fast} ${animations.easeOutCubic};
  color: ${colors.primary};
`;
